import CacheMan from "../jslibs/CacheMan";
import GError from "../jslibs/GError";
import { ISelectRow } from "../libs/dropdown/Dropdown";
import Recipes, { IRecipe, TUnits } from "../shared/Recipes";
import FoodApi from "./FoodApi";

export const UnitOptions:ISelectRow<string>[] = TUnits.map(unit => ({value:unit,label:unit}))
export function unit2option(unit:string) : ISelectRow<string> { return UnitOptions.find(u => u.value==unit)! }

export default class RecipeCache extends CacheMan<string, Recipes> {
    static _i:RecipeCache
    static get i(){
        if (!this._i) this._i = new RecipeCache("recipes", 3600)
        return this._i
    }
    async fetch(userId:string): Promise<Recipes> {
        return new Recipes(userId, await FoodApi.i.recipes())
    }
    async fetchBatch(keys: string[]): Promise<Recipes[]> {
        throw "Not implemented"
    }
    async getRecipes(){
        if (!FoodApi.i.userId) throw new GError.NotAuthorized()
        return  this.get(FoodApi.i.userId)
    }
    async addRecipe(name:string,desc:string,servings:number){
        const recipes = await this.getRecipes()
        const recipe = await FoodApi.i.addRecipe(name,desc,servings)
        recipes.update(recipe)
        return this.add(recipes.userId, recipes.update(recipe))
    }
    async updateRecipe(id:string,data:Partial<IRecipe>){
        const recipes = await this.getRecipes()
        const recipe = await FoodApi.i.updateRecipe(id, data)
        recipes.update(recipe)
        return this.add(recipes.userId, recipes.update(recipe))
    }
}
